import { Tracker } from 'meteor/tracker';

const COGIBULLE_ZINDEX_BASE = 1400;
const COGIBULLE_OVERLAY_ZINDEX = 200000;
const PAD_STACK_STORAGE_KEY = 'cogivoice_hub_pad_stack_v1';

const gFenetresCogibulle = [];
let gCogibulleDernierZIndex = COGIBULLE_ZINDEX_BASE;
let gPadsStack = lit_pile_pads_local_storage ();

function lit_pile_pads_local_storage ()
  {
    if (typeof localStorage === 'undefined') return [];
    try
      {
        const tRaw = localStorage.getItem (PAD_STACK_STORAGE_KEY);
        if (!tRaw) return [];
        const tListe = JSON.parse (tRaw);
        if (!Array.isArray (tListe)) return [];
        return tListe.filter ((pId) => typeof pId === 'string' && pId);
      }
    catch (e) { return []; }
  }

function ecrit_pile_pads_local_storage ()
  {
    if (typeof localStorage === 'undefined') return;
    try { localStorage.setItem (PAD_STACK_STORAGE_KEY, JSON.stringify (gPadsStack)); }
    catch (e) {}
  }

function position_pile_pad (pStackId)
  {
    if (!pStackId) return -1;
    return gPadsStack.indexOf (pStackId);
  }

function assure_presence_dans_pile_pad (pStackId)
  {
    if (!pStackId) return false;
    if (position_pile_pad (pStackId) !== -1) return false;
    gPadsStack.push (pStackId);
    ecrit_pile_pads_local_storage ();
    return true;
  }

function retire_de_pile_pad (pStackId)
  {
    const tIndex = position_pile_pad (pStackId);
    if (tIndex === -1) return false;
    gPadsStack.splice (tIndex, 1);
    ecrit_pile_pads_local_storage ();
    return true;
  }

function place_en_haut_de_pile_pad (pStackId)
  {
    if (!pStackId) return false;
    retire_de_pile_pad (pStackId);
    gPadsStack.push (pStackId);
    ecrit_pile_pads_local_storage ();
    return true;
  }

function zindex_persistant_pad (pStackId)
  {
    const tIndex = position_pile_pad (pStackId);
    return tIndex === -1 ? null : (COGIBULLE_ZINDEX_BASE + tIndex + 1);
  }

function synchronise_etat_visuel_pads ()
  {
    let tPadPremierPlan = null;
    let tPadPremierPlanZIndex = -Infinity;
    for (const tFenetre of gFenetresCogibulle)
      {
        if (!tFenetre || typeof tFenetre.isOpen !== 'function' || !tFenetre.isOpen ()) continue;
        const tZIndex = Number (typeof tFenetre.getZIndex === 'function' ? tFenetre.getZIndex () : 0) || 0;
        if (!tPadPremierPlan || tZIndex > tPadPremierPlanZIndex)
          {
            tPadPremierPlan = tFenetre;
            tPadPremierPlanZIndex = tZIndex;
          }
      }
    for (const tFenetre of gFenetresCogibulle)
      {
        if (!tFenetre || typeof tFenetre.getElement !== 'function') continue;
        const tElement = tFenetre.getElement ();
        if (!(tElement && tElement.classList)) continue;
        tElement.classList.toggle ('is_pad_front', tFenetre === tPadPremierPlan);
      }
  }

function synchronise_zindex_pads_persistes ()
  {
    let tMaxZIndex = COGIBULLE_ZINDEX_BASE + gPadsStack.length;
    for (const tFenetre of gFenetresCogibulle)
      {
        if (!tFenetre || typeof tFenetre.syncPersistedZIndex !== 'function') continue;
        const tZIndex = Number (tFenetre.syncPersistedZIndex ()) || COGIBULLE_ZINDEX_BASE;
        if (tZIndex > tMaxZIndex) tMaxZIndex = tZIndex;
      }
    gCogibulleDernierZIndex = tMaxZIndex;
    synchronise_etat_visuel_pads ();
  }

function prochain_zindex_cogibulle ()
  {
    gCogibulleDernierZIndex += 1;
    return gCogibulleDernierZIndex;
  }

function lit_booleen_local_storage (pKey, pDefaut = false)
  {
    if (!pKey) return !!pDefaut;
    try
      {
        const tVal = localStorage.getItem (pKey);
        if (tVal === null) return !!pDefaut;
        return tVal === '1' || tVal === 'true';
      }
    catch (e) { return !!pDefaut; }
  }

function ecrit_booleen_local_storage (pKey, pValeur)
  {
    if (!pKey) return;
    try { localStorage.setItem (pKey, pValeur ? '1' : '0'); }
    catch (e) {}
  }

function lit_boite_local_storage (pKey)
  {
    if (!pKey) return null;
    try
      {
        const tRaw = localStorage.getItem (pKey);
        if (!tRaw) return null;
        const tObj = JSON.parse (tRaw);
        if (!tObj || typeof tObj !== 'object') return null;
        const {x, y, w, h} = tObj;
        if ([x, y, w, h].some ((pVal) => typeof pVal !== 'number' || !isFinite (pVal)))
          return null;
        return {x, y, w, h};
      }
    catch (e) { return null; }
  }

function ecrit_boite_local_storage (pKey, pBoite)
  {
    if (!pKey || !pBoite) return;
    try { localStorage.setItem (pKey, JSON.stringify (pBoite)); }
    catch (e) {}
  }

export function cree_stockage_local_fenetre_cogibulle ({boxKey, openKey, stackId})
  {
    return {
      stackId  : stackId || openKey || boxKey || null,
      readBox  : () => lit_boite_local_storage (boxKey),
      writeBox : (pBoite) => ecrit_boite_local_storage (boxKey, pBoite),
      readOpen : () => lit_booleen_local_storage (openKey, false),
      writeOpen: (pOuvert) => ecrit_booleen_local_storage (openKey, pOuvert),
    };
  }

export function cree_fenetre_cogibulle (pConfig)
  {
    const tConfig = pConfig || {};
    const tStorage = tConfig.storage || {};
    const tStackId = tConfig.stackId || tStorage.stackId
      || (typeof tConfig.selector === 'string' ? tConfig.selector : null);
    const tState =
      {
        box                : null,
        drag               : null,
        resize             : null,
        interactionOverlay : null,
        zIndex             : COGIBULLE_ZINDEX_BASE,
        restoreRequested   : false,
      };

    function get_margin ()
      {
        return Math.max (0, Number (tConfig.margin) || 0);
      }

    function get_min_width ()
      {
        return Math.max (1, Number (tConfig.minWidth) || 1);
      }

    function get_min_height ()
      {
        return Math.max (1, Number (tConfig.minHeight) || 1);
      }

    function get_safe_top ()
      {
        const tMargin = get_margin ();
        const tVal = typeof tConfig.safeTop === 'function'
          ? Number (tConfig.safeTop ())
          : tMargin;
        return Math.max (tMargin, isFinite (tVal) ? tVal : tMargin);
      }

    function get_bounds ()
      {
        const tMargin = get_margin ();
        const tSafeTop = get_safe_top ();
        return {
          minX : tMargin,
          minY : tSafeTop,
          maxX : Math.max (tMargin, window.innerWidth - tMargin),
          maxY : Math.max (tSafeTop, window.innerHeight - tMargin),
        };
      }

    function get_element ()
      {
        if (typeof document === 'undefined') return null;
        if (typeof tConfig.selector === 'function') return tConfig.selector ();
        if (!tConfig.selector) return null;
        return document.querySelector (tConfig.selector);
      }

    function is_open ()
      {
        return typeof tConfig.isOpen === 'function' ? !!tConfig.isOpen () : false;
      }

    function set_open (pOpen)
      {
        if (typeof tConfig.setOpen === 'function') tConfig.setOpen (!!pOpen);
      }

    function load_box ()
      {
        return typeof tStorage.readBox === 'function' ? tStorage.readBox () : null;
      }

    function save_box ()
      {
        if (tState.box && typeof tStorage.writeBox === 'function')
          tStorage.writeBox (tState.box);
      }

    function reload_restore_request ()
      {
        tState.restoreRequested = typeof tStorage.readOpen === 'function'
          ? !!tStorage.readOpen ()
          : false;
        return tState.restoreRequested;
      }

    function save_open (pOpen)
      {
        tState.restoreRequested = !!pOpen;
        if (typeof tStorage.writeOpen === 'function') tStorage.writeOpen (!!pOpen);
      }

    function default_box ()
      {
        const tBounds = get_bounds ();
        const tMinW = get_min_width ();
        const tMinH = get_min_height ();
        const tCustomDefault = typeof tConfig.defaultBox === 'function'
          ? tConfig.defaultBox ()
          : tConfig.defaultBox;
        if (tCustomDefault && typeof tCustomDefault === 'object')
          {
            const tBox = {
              x : Number (tCustomDefault.x),
              y : Number (tCustomDefault.y),
              w : Number (tCustomDefault.w),
              h : Number (tCustomDefault.h),
            };
            if ([tBox.x, tBox.y, tBox.w, tBox.h].every ((pVal) => typeof pVal === 'number' && isFinite (pVal)))
              {
                const tMaxW = Math.max (tMinW, tBounds.maxX - tBounds.minX);
                const tMaxH = Math.max (tMinH, tBounds.maxY - tBounds.minY);
                tBox.w = Math.max (tMinW, Math.min (tMaxW, tBox.w));
                tBox.h = Math.max (tMinH, Math.min (tMaxH, tBox.h));
                tBox.x = Math.max (tBounds.minX, Math.min (tBounds.maxX - tBox.w, tBox.x));
                tBox.y = Math.max (tBounds.minY, Math.min (tBounds.maxY - tBox.h, tBox.y));
                return tBox;
              }
          }
        const tPreferredW = Math.max (tMinW, Number (tConfig.preferredWidth) || tMinW);
        const tPreferredH = Math.max (tMinH, Number (tConfig.preferredHeight) || tMinH);
        const tRatioW = Math.max (0.1, Math.min (1, Number (tConfig.widthViewportRatio) || 0.92));
        const tRatioH = Math.max (0.1, Math.min (1, Number (tConfig.heightViewportRatio) || 0.9));
        const tMaxW = Math.max (tMinW, tBounds.maxX - tBounds.minX);
        const tMaxH = Math.max (tMinH, tBounds.maxY - tBounds.minY);
        const tW = Math.max (
          tMinW,
          Math.min (tPreferredW, Math.floor (window.innerWidth * tRatioW), tMaxW)
        );
        const tH = Math.max (
          tMinH,
          Math.min (tPreferredH, Math.floor ((window.innerHeight - tBounds.minY) * tRatioH), tMaxH)
        );
        return {
          x : Math.max (tBounds.minX, Math.floor ((window.innerWidth - tW) / 2)),
          y : Math.max (tBounds.minY, Math.floor ((window.innerHeight - tH + tBounds.minY) / 2)),
          w : tW,
          h : tH,
        };
      }

    function normalise_box (pBoite)
      {
        if (typeof window === 'undefined') return pBoite || null;
        const tBounds = get_bounds ();
        const tMinW = get_min_width ();
        const tMinH = get_min_height ();
        const tMaxW = Math.max (tMinW, tBounds.maxX - tBounds.minX);
        const tMaxH = Math.max (tMinH, tBounds.maxY - tBounds.minY);
        if (!pBoite) return default_box ();
        let {x, y, w, h} = pBoite;
        if ([x, y, w, h].some ((pVal) => typeof pVal !== 'number' || !isFinite (pVal)))
          return default_box ();
        w = Math.max (tMinW, Math.min (tMaxW, w));
        h = Math.max (tMinH, Math.min (tMaxH, h));
        x = Math.max (tBounds.minX, Math.min (tBounds.maxX - w, x));
        y = Math.max (tBounds.minY, Math.min (tBounds.maxY - h, y));
        return {x, y, w, h};
      }

    function ensure_box ()
      {
        tState.box = normalise_box (tState.box || load_box ());
        return tState.box;
      }

    function sync_persisted_zindex ()
      {
        const tPersistedZIndex = zindex_persistant_pad (tStackId);
        if (tPersistedZIndex !== null) tState.zIndex = tPersistedZIndex;
        const tElement = get_element ();
        if (tElement) tElement.style.zIndex = String (tState.zIndex || COGIBULLE_ZINDEX_BASE);
        synchronise_etat_visuel_pads ();
        return tState.zIndex;
      }

    function bring_to_front ()
      {
        if (tStackId)
          {
            place_en_haut_de_pile_pad (tStackId);
            synchronise_zindex_pads_persistes ();
            return tState.zIndex;
          }
        tState.zIndex = prochain_zindex_cogibulle ();
        const tElement = get_element ();
        if (tElement) tElement.style.zIndex = String (tState.zIndex);
        synchronise_etat_visuel_pads ();
        return tState.zIndex;
      }

    function apply_box ()
      {
        const tElement = get_element ();
        if (!tElement) return;
        const tBox = ensure_box ();
        tElement.style.position = tConfig.position || 'fixed';
        tElement.style.left = tBox.x + 'px';
        tElement.style.top = tBox.y + 'px';
        tElement.style.width = tBox.w + 'px';
        tElement.style.height = tBox.h + 'px';
        tElement.style.margin = '0';
        tElement.style.zIndex = String (tState.zIndex || COGIBULLE_ZINDEX_BASE);
      }

    function remove_interaction_overlay ()
      {
        if (typeof document === 'undefined') return;
        document.body.style.userSelect = '';
        document.body.style.cursor = '';
        if (tState.interactionOverlay && tState.interactionOverlay.parentNode)
          {
            try { tState.interactionOverlay.parentNode.removeChild (tState.interactionOverlay); }
            catch (e) {}
          }
        tState.interactionOverlay = null;
      }

    function create_interaction_overlay (pCursor)
      {
        remove_interaction_overlay ();
        if (typeof document === 'undefined') return;
        const tOverlay = document.createElement ('div');
        const tZIndex = Math.max (COGIBULLE_OVERLAY_ZINDEX, (tState.zIndex || COGIBULLE_ZINDEX_BASE) + 1);
        tOverlay.style.cssText =
            'position:fixed;inset:0;background:transparent;touch-action:none;'
          + 'z-index:' + tZIndex + ';cursor:' + pCursor + ';';
        document.body.appendChild (tOverlay);
        document.body.style.userSelect = 'none';
        document.body.style.cursor = pCursor;
        tState.interactionOverlay = tOverlay;
      }

    function drag_move (pEvent)
      {
        if (!tState.drag || !tState.box) return;
        if (tState.drag.pointerId !== undefined && pEvent.pointerId !== tState.drag.pointerId) return;
        const tBounds = get_bounds ();
        tState.box.x = Math.max (
          tBounds.minX,
          Math.min (tBounds.maxX - tState.box.w, pEvent.clientX - tState.drag.offsetX)
        );
        tState.box.y = Math.max (
          tBounds.minY,
          Math.min (tBounds.maxY - tState.box.h, pEvent.clientY - tState.drag.offsetY)
        );
        apply_box ();
      }

    function drag_end (pEvent)
      {
        if (!tState.drag) return;
        if (pEvent && tState.drag.pointerId !== undefined && pEvent.pointerId !== tState.drag.pointerId)
          return;
        tState.drag = null;
        document.removeEventListener ('pointermove', drag_move);
        document.removeEventListener ('pointerup', drag_end);
        document.removeEventListener ('pointercancel', drag_end);
        remove_interaction_overlay ();
        save_box ();
      }

    function resize_move (pEvent)
      {
        if (!tState.resize || !tState.box) return;
        if (tState.resize.pointerId !== undefined && pEvent.pointerId !== tState.resize.pointerId) return;
        const tBounds = get_bounds ();
        tState.box.w = Math.max (
          get_min_width (),
          Math.min (tBounds.maxX - tState.box.x, tState.resize.startW + (pEvent.clientX - tState.resize.startX))
        );
        tState.box.h = Math.max (
          get_min_height (),
          Math.min (tBounds.maxY - tState.box.y, tState.resize.startH + (pEvent.clientY - tState.resize.startY))
        );
        apply_box ();
      }

    function resize_end (pEvent)
      {
        if (!tState.resize) return;
        if (pEvent && tState.resize.pointerId !== undefined && pEvent.pointerId !== tState.resize.pointerId)
          return;
        tState.resize = null;
        document.removeEventListener ('pointermove', resize_move);
        document.removeEventListener ('pointerup', resize_end);
        document.removeEventListener ('pointercancel', resize_end);
        remove_interaction_overlay ();
        save_box ();
      }

    const tController =
      {
        getElement               : get_element,
        isOpen                   : is_open,
        getStackId               : () => tStackId,
        defaultBox               : default_box,
        normaliseBox             : normalise_box,
        applyBox                 : apply_box,
        bringToFront             : bring_to_front,
        saveBox                  : save_box,
        removeInteractionOverlay : remove_interaction_overlay,
        reloadRestoreRequest     : reload_restore_request,
        shouldRestore            : () => tState.restoreRequested,
        getZIndex                : () => tState.zIndex,
        syncPersistedZIndex      : sync_persisted_zindex,
        open (pOptions = {})
          {
            tState.restoreRequested = false;
            tState.box = normalise_box ((pOptions && pOptions.box) || tState.box || load_box ());
            save_open (true);
            set_open (true);
            if (pOptions.fromRestore)
              {
                assure_presence_dans_pile_pad (tStackId);
                synchronise_zindex_pads_persistes ();
              }
            else bring_to_front ();
            Tracker.afterFlush (() =>
              {
                sync_persisted_zindex ();
                apply_box ();
                synchronise_etat_visuel_pads ();
              });
            return true;
          },
        close (pOptions = {})
          {
            tController.cleanupTransient ();
            if (pOptions.persist !== false) save_open (false);
            else tState.restoreRequested = typeof tStorage.readOpen === 'function'
              ? !!tStorage.readOpen ()
              : tState.restoreRequested;
            set_open (false);
            if (pOptions.persist !== false)
              {
                retire_de_pile_pad (tStackId);
                synchronise_zindex_pads_persistes ();
              }
            Tracker.afterFlush (() => { synchronise_etat_visuel_pads (); });
            return true;
          },
        hideWithoutPersist ()
          {
            tController.cleanupTransient ();
            set_open (false);
            reload_restore_request ();
            Tracker.afterFlush (() => { synchronise_etat_visuel_pads (); });
          },
        cleanupTransient ()
          {
            tState.drag = null;
            tState.resize = null;
            document.removeEventListener ('pointermove', drag_move);
            document.removeEventListener ('pointerup', drag_end);
            document.removeEventListener ('pointercancel', drag_end);
            document.removeEventListener ('pointermove', resize_move);
            document.removeEventListener ('pointerup', resize_end);
            document.removeEventListener ('pointercancel', resize_end);
            remove_interaction_overlay ();
          },
        restoreIfPossible (pOpenFn)
          {
            if (!tState.restoreRequested) return false;
            const tOuvert = typeof pOpenFn === 'function'
              ? pOpenFn ({fromRestore : true})
              : tController.open ({fromRestore : true});
            if (tOuvert === false) return false;
            tState.restoreRequested = false;
            return true;
          },
        syncToViewport ()
          {
            if (!is_open () || !tState.box) return;
            tState.box = normalise_box (tState.box);
            apply_box ();
            save_box ();
          },
        notePointerDown ()
          {
            if (!is_open ()) return false;
            bring_to_front ();
            return true;
          },
        startDrag (pEvent)
          {
            ensure_box ();
            if (!tState.box) return;
            if (pEvent.pointerType === 'mouse' && pEvent.button !== 0) return;
            bring_to_front ();
            tState.drag = {
              pointerId : pEvent.pointerId,
              offsetX   : pEvent.clientX - tState.box.x,
              offsetY   : pEvent.clientY - tState.box.y,
            };
            create_interaction_overlay ('grabbing');
            document.addEventListener ('pointermove', drag_move);
            document.addEventListener ('pointerup', drag_end);
            document.addEventListener ('pointercancel', drag_end);
            pEvent.preventDefault ();
          },
        startResize (pEvent)
          {
            ensure_box ();
            if (!tState.box) return;
            if (pEvent.pointerType === 'mouse' && pEvent.button !== 0) return;
            bring_to_front ();
            tState.resize = {
              pointerId : pEvent.pointerId,
              startX    : pEvent.clientX,
              startY    : pEvent.clientY,
              startW    : tState.box.w,
              startH    : tState.box.h,
            };
            create_interaction_overlay ('nwse-resize');
            document.addEventListener ('pointermove', resize_move);
            document.addEventListener ('pointerup', resize_end);
            document.addEventListener ('pointercancel', resize_end);
            pEvent.preventDefault ();
            pEvent.stopPropagation ();
          },
        handleEscape (pEvent)
          {
            if (!is_open ()) return false;
            if (pEvent && typeof pEvent.preventDefault === 'function') pEvent.preventDefault ();
            if (typeof tConfig.onEscape === 'function')
              {
                tConfig.onEscape (pEvent, tController);
                return true;
              }
            tController.close ();
            return true;
          },
      };

    gFenetresCogibulle.push (tController);
    reload_restore_request ();
    return tController;
  }

export function gere_echap_fenetre_cogibulle (pEvent)
  {
    const tOuvertes = gFenetresCogibulle
      .filter ((pFenetre) => pFenetre && typeof pFenetre.isOpen === 'function' && pFenetre.isOpen ())
      .sort ((a, b) => (b.getZIndex () || 0) - (a.getZIndex () || 0));
    if (!tOuvertes.length) return false;
    tOuvertes[0].handleEscape (pEvent);
    return true;
  }
